<template>
  <div class="role-member-container" ref="container">
    <div ref="containerTitle">
      <div class="container-title title-second">
        <div>全部成员，共 {{ pageparm.total }} 人</div>
        <div>
          <el-button size="mini" plain type="primary" @click.stop="handleAdd"
            >添加成员</el-button
          >
        </div>
      </div>
    </div>
    <!-- 表格 -->
    <tableWrap>
      <template #table>
        <el-table
          :data="tableData"
          style="font-size: 13px;color:#3D3D3D;"
          fit
          highlight-current-row
          align="center"
          :header-cell-style="{ background: '#F9F9F9' }"
          height="calc(100vh - 345px)"
          ref="cusChatTable"
        >
          <el-table-column
            prop="userName"
            label="姓名"
            show-overflow-tooltip
            min-width="100"
          >
          </el-table-column>
          <el-table-column prop="qwAccount" label="企业号" min-width="100">
          </el-table-column>
          <!-- 隐藏 2025.04.16 肖恒说熊鑫说腾讯没有返回就此隐藏-->
          <!-- <el-table-column
            prop="mobile"
            label="手机号"
            min-width="100">
          </el-table-column> -->
          <el-table-column label="操作" min-width="100">
            <template slot-scope="scope">
              <el-button
                v-if="true"
                class="table-button"
                type="text"
                size="small"
                @click.stop="handleDel(scope.$index, scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </template>
      <template #pagination>
        <Pagination
          ref="pageContainer"
          :childMsg="pageparm"
          :pageSizes="pageSizes"
          @callBack="callBack"
        ></Pagination>
      </template>
    </tableWrap>
    <!-- 添加人员树 -->
    <StaffTree
      title="添加成员"
      :dialogVisibleTree="dialogVisibleTree"
      :currentSelectMember="currentSelectMember"
      @closeTree="closeTree"
      @clickSubmitTree="clickSubmitTree"
    ></StaffTree>
    <TipDialog ref="tipdialog" />
  </div>
</template>
<script>
import { getActivityDepartStaff } from "@/api/activeCode/activeCode.js";
import { getOrganization } from "@/api/staffTree/staffTree.js";
import { createRoleEmp, getRoleEmp, deleteRoleEmp } from "@/api/role/role.js";
// import AddMemberView from "@/components/staffTree.vue"
import StaffTree from "@/components/staffTree/staffTree.vue";
// import StaffTreeTwo from '@/components/staffTree/staffTreeTwo.vue'
import TipDialog from "@/views/system/roleComponents/tipDialog.vue";
import tableWrap from "@/components/tabelWrap.vue";
export default {
  name: "RoleMembers",
  props: ["roleEmp", "roleId"],
  components: {
    // AddMemberView,
    TipDialog,
    tableWrap,
    StaffTree,
    // StaffTreeTwo
  },
  data() {
    return {
      pageparm: {
        currentPage: 1,
        pageSize: 20,
        total: 0,
      },
      toBeReplaced: [
        {
          name: "陈其雄",
          userId: "",
        },
      ],
      pageSizes: [20, 50, 100, 200, 500], //分页条数
      tableData: [],
      dialogVisibleTree: false, // 成员树
      currentSelectMember: [],
      beforSelectMember: [],
      currentRoleEmp: [], // 存放该角色所有成员
      addempParams: {
        roleId: "",
        userList: [],
      },
      deleteRoleEmpParams: {
        roleId: "",
        userId: "",
      },
      // stutusFlag: true,                   // true为所有者，false为非所有者
      getListParams: {
        roleId: "",
        pageNum: 1,
        pageSize: 20,
      },
      allStaff: [],
    };
  },
  methods: {
    // 树关闭
    closeTree(val) {
      this.dialogVisibleTree = false;
    },
    handleAdd() {
      this.dialogVisibleTree = true;
    },
    // 成员树的事件
    clickSubmitTree(val) {
      this.beforSelectMember = val.currentMember;
      this.dialogVisibleTree = false;
      this.addempParams.userList = [];
      let arr = JSON.parse(JSON.stringify(val.sendArray));
      arr.forEach((item) => {
        let obj = {
          userId: item.userId,
          userName: item.userName,
        };
        this.addempParams.userList.push(obj);
      });
      // 发送请求
      this.addRoleEmp(this.addempParams);
    },
    callBack(parm) {
      this.getListParams.pageNum = parm.currentPage;
      this.getListParams.pageSize = parm.pageSize;
      this.getRoleEmp(this.getListParams);
    },
    // 删除
    handleDel(index, row) {
      let that = this;
      that
        .$confirm("您确定删除该成员？提交后将无法撤回", {
          distinguishCancelAndClose: true,
          closeOnClickModal: false,
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          iconClass: "el-icon-warning",
          customClass: "delete-messege",
          center: true,
        })
        .then((res) => {
          that.deleteRoleEmpParams.userId = row.userId;
          that.deleteEmp(that.deleteRoleEmpParams);
        })
        .catch((action) => {
          // that.$message("取消删除");
          that.$message({
            message: "取消删除",
            type: "info",
            offset: 30,
            customClass: "info-message",
            duration: 0,
          });
        });
    },
    // 删除成员请求
    deleteEmp(params) {
      deleteRoleEmp(params, localStorage.getItem("Authorization")).then(
        (res) => {
          if (res.error.code == 200) {
            this.$message({
              type: "success",
              message: "删除成员成功!",
            });
            // 刷新页面
            this.getListParams.pageNum = 1;
            this.getRoleEmp(this.getListParams);
            this.$emit("reGet");
          } else {
            /** 如果删除提示存在就使用删除提示，没有走前端提示  */
            if (res && res.error && res.error.message) {
              this.$message.error(res.error.message);
            } else {
              this.$message.error("删除成员失败,请重试！");
            }
          }
        }
      );
    },
    //获取所有员工&部门
    async getDepartStaff() {
      let params = {
        mark: 2,
      };
      await getOrganization(params, localStorage.getItem("Authorization"))
        .then((res) => {
          if (res.error.code == 200) {
            this.$store.dispatch("tagsView/setTree1", res.data);
            this.allStaff = res.data.empList;
          }
        })
        .catch((err) => {});
    },
    // 添加成员 请求
    addRoleEmp(params) {
      createRoleEmp(params, localStorage.getItem("Authorization"))
        .then((res) => {
          if (res.error.code == 200) {
            this.dialogVisibleTree = false;
            this.$message({
              type: "success",
              message: "添加成功!",
            });
            // 刷新页面
            this.currentSelectMember = this.beforSelectMember;
            this.getListParams.pageNum = 1;
            this.getRoleEmp(this.getListParams);
            this.$emit("reGet");
          } else if (res.error.code == 203) {
            // this.$refs.tipdialog.show(res.data)
            this.$message.error(res.error.message);
          } else {
            this.$message.error("添加成员失败,请重试！");
          }
        })
        .catch((action) => {
          this.$message.error("添加成员失败,请重试！");
        });
    },
    // 获取成员列表
    getRoleEmp(params) {
      getRoleEmp(params, localStorage.getItem("Authorization"))
        .then((res) => {
          if (res.error.code == 200) {
            this.tableData = res.data.roleEmpList;
            this.pageparm.currentPage = this.getListParams.pageNum;
            this.pageparm.pageSize = this.getListParams.pageSize;
            this.pageparm.total = res.data.roleEmpTotal;
          }
        })
        .catch((action) => {
          this.$message.error("获取成员列表失败");
        });
    },
  },
  created() {
    // 获取所有员工数据
    this.getDepartStaff();
  },
  watch: {
    // 弃用 2022.8.12
    // status: {
    //   handler(newVal,oldVal) {
    //     if(newVal == 0) {
    //       // 所有者
    //       this.stutusFlag = true
    //     }else {
    //       // 非所有者
    //       this.stutusFlag = false
    //     }
    //   }
    // },
    roleEmp: {
      async handler(newVal, oldVal) {
        let selectAllStaff = JSON.parse(JSON.stringify(newVal));
        this.currentSelectMember = [];
        if (selectAllStaff.length != 0) {
          let userIds = selectAllStaff.map((v) => {
            return v.userId;
          });
          if (this.allStaff.length == 0) {
            // let tree1 = this.$store.state.tagsView.tree1;
            // if (tree1 && tree1.length != 0) {
            //   this.allStaff = tree1.empList;
            // } else {
              await this.getDepartStaff();
            // }
          }
          this.currentSelectMember = this.allStaff.filter((v) => {
            return userIds.includes(v.userId) == true;
          });
          console.log("this.currentSelectMember", this.currentSelectMember);
        }
      },
      deep: true,
    },
    roleId: {
      handler(newVal, oldVal) {
        this.addempParams.roleId = newVal;
        this.getListParams.roleId = newVal;
        this.deleteRoleEmpParams.roleId = newVal;
        this.getListParams.pageNum = 1;
        this.getRoleEmp(this.getListParams);
      },
    },
  },
};
</script>
<style lang="scss" scoped>
.role-member-container {
  padding: 15px 0 0 15px;
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  .container-title {
    margin-bottom: 20px;
    color: #aaaaaa;
    font-size: 13px;
  }
  .title-second {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 11px !important;
  }
  .emp-name {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
}
</style>
